import charwe from "../images/charwe.png";
import betty from "../images/betty.png";
import alice from "../images/alice.png";
import loongoPod from "../images/loongo-pod.png";

export const podcastDetails = [
  {
    title: "Leading Ladies S3 E3 - Charwe Nehanda Nyakasikana",
    date: "13th January, 2022",
    image: charwe,
  },
  {
    title: "Leading Ladies S3 E7 - Betty Chilombo Chilunga",
    date: "13th January, 2022",
    image: betty,
  },
  {
    title: "Leading Ladies S2 E6 - Alice Mulenga Lanshina",
    date: "13th January, 2022",
    image: alice,
  },
  {
    title: "Leading Ladies Zambia S1 E3 - Loongo",
    date: "13th January, 2022",
    image: loongoPod,
  },
];
